import { render, staticRenderFns } from "./PromotionReviewing.vue?vue&type=template&id=8df17296&scoped=true&"
import script from "./PromotionReviewing.vue?vue&type=script&lang=js&"
export * from "./PromotionReviewing.vue?vue&type=script&lang=js&"
import style0 from "./PromotionReviewing.vue?vue&type=style&index=0&id=8df17296&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8df17296",
  null
  
)

export default component.exports